<div class="rn-page">
  @if (loading) {
    <div class="loading-page">
      <h2>Loading Two Way Messaging</h2>
      <app-spinner></app-spinner>
    </div>
  }

  @if (error && !loading) {
    <div class="rn-page__section">
      <div class="rn-page--error">
        <h1>{{error}}</h1>
      </div>
    </div>
  }

  @if (!error && !loading) {
    <div class="rn-page__section--left">
      <div class="tag-select">
        @if (tags) {
          <tag-select [tags]="tags" (filter)="tagFilterChange($event)"></tag-select>
        }
      </div>
      <div class="launch-select">
        @if (launches) {
          <launch-select [launches]="launches" (filter)="launchFilterChange($event)"></launch-select>
        }
      </div>
      <hr>
        <div class="assigned-messages">
          @if (tags) {
            <assigned
              [tags]="tags"
              [tagFilter]="$tagFilter"
              [launchFilter]="$launchFilter"
              (selectedChannelEmitter)="setSelectedChannel($event)"
            [$selectedChannel]="$selectedChannel"></assigned>
          }
        </div>
        <hr>
          <div class="unassigned-messages">
            @if (tags) {
              <unassigned
                [tags]="tags"
                [tagFilter]="$tagFilter"
                [launchFilter]="$launchFilter"
              (selectedChannelEmitter)="setSelectedChannel($event)"></unassigned>
            }
          </div>
        </div>
        <div class="rn-page__section--middle">
          @if (selectedChannel) {
            <div class="wrapper messaging">
              <message-window
                (textAreaHasFocus)="textAreaFocused($event)"
                [selectedChannel]="selectedChannel"
              [$selectedChannel]="$selectedChannel"></message-window>
            </div>
          }
        </div>
        <div class="rn-page__section--right">
          <two-way-customer-details [$selectedChannel]="$selectedChannel"></two-way-customer-details>
        </div>
      }
      <audio #audioControl>
        <source src="/assets/audio/ping-bing.wav" type="audio/wav" />
        <source src="/assets/audio/ping-bing.ogg" type="audio/ogg" />
      </audio>

    </div>
